import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./field.scss";
import {
  lblEmailOrMobileNumber,
  txtEnterEmailOrPhone,
  txtThisWillLoginId,
} from "../../../dataBaseFile/label";
import { Form } from "react-bootstrap";
import InputGroup from "react-bootstrap/InputGroup";
import { number } from "yup/lib/locale";
import { ImGift } from "react-icons/im";
import Select from 'react-select';
import { getCountryCode } from "../../../service/api/countryCode/countryCode";
import { setCountryArray } from "../../../feature/countryArray/countryArray";
import InputMask from 'react-input-mask';

const EmailPhoneCombine = ({
  inputValue,
  handleChangeCode,
  handleOnBlur,
  handleInputValue,
  errorOccured,
  isEnteringNumber,
  setIsEnteringNumber,
  errorMessage,
  defaultCodeValue = 1,
  isSignUp = false,
  label = "",
  isRequired = false,
  autoF = false
}) => {
  const dispatch = useDispatch();
  const { countryCodeArr } = useSelector((state) => state.country);
  const [activated, setActivated] = useState(false);
  const labelRef = useRef(null);
  const inputRef = useRef(null);
  const [coverWidth, setCoverWidth] = useState(0);
  const [numberDisplay, setNumberDisplay] = useState(inputValue);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [phoneMask, setPhoneMask] = useState('');
  useEffect(() => {

    if (!inputValue) {
      setNumberDisplay(""); // Reset when inputValue is empty
      return;
    }

    const safeInputValue = String(inputValue); // Convert inputValue to a string safely
    let cleanedInputValue = safeInputValue.replace(/[\(\)\-\_\s]/g, ""); // Remove formatting characters
    const isNumericInput = /^[0-9]*$/.test(cleanedInputValue);

    if (isNumericInput && cleanedInputValue.length <= 10) {
      // If numeric input and length <= 10, apply phone formatting
      if (selectedCountry) {
        const formattedValue = formatPhoneNumber(cleanedInputValue, selectedCountry.phone_number_format);
        setNumberDisplay(formattedValue);
      } else {
        setNumberDisplay(cleanedInputValue);
      }
    } else {
      // If it's not a valid phone number, treat it as an email
      setNumberDisplay(safeInputValue); // Directly show input as email
    }


    // if (!inputValue) {
    //   setNumberDisplay(""); // Reset when inputValue is empty or undefined
    //   return;
    // }

    // const safeInputValue = String(inputValue); // Convert inputValue to a string safely

    // let cleanedInputValue = safeInputValue.replace(/[\(\)\-\_\s]/g, ""); // Remove formatting characters
    // const isNumericInput = /^[0-9]*$/.test(cleanedInputValue);

    // if (isNumericInput) {
    //   if (selectedCountry) {
    //     const formattedValue = formatPhoneNumber(cleanedInputValue, selectedCountry.phone_number_format);
    //     setNumberDisplay(formattedValue);
    //   } else {
    //     setNumberDisplay(cleanedInputValue);
    //   }
    // } else {
    //   setNumberDisplay(safeInputValue); // Display email directly
    // }


  }, [inputValue, selectedCountry]);

  useEffect(() => {
    if (countryCodeArr.length === 0) {
      let details = {};
      dispatch(
        getCountryCode(details, (res) => {
          dispatch(setCountryArray(res.data));
        }, (err) => { })
      );
    }
  }, []);

  useEffect(() => {
    setCoverWidth(
      labelRef.current ? labelRef.current.getBoundingClientRect().width + 11 : 0
    );
    if (isEnteringNumber || inputValue?.length > 0) {
      setActivated(true);
    }
  }, [labelRef]);

  useEffect(() => {
    const defaultOption = countryCodeArr.find(
      (country) => country.country_id_ids === defaultCodeValue
    );

    if (defaultOption) {
      setSelectedCountry(defaultOption);
      setPhoneMask(defaultOption.phone_number_format.replace(/0/g, '9'));

      // If the user is entering a phone number, reformat it using the new format
      if (isEnteringNumber && numberDisplay) {
        const unformattedValue = numberDisplay.replace(/\D/g, ''); // Remove non-numeric characters
        const formattedValue = formatPhoneNumber(unformattedValue, defaultOption.phone_number_format);
        setNumberDisplay(formattedValue); // Display the number in the new format
      }
    }

    // Old approach working perfectly fine
    // const defaultOption = countryCodeArr.find(
    //   (country) => country.country_id_ids === defaultCodeValue
    // );
    // if (defaultOption) {
    //   setSelectedCountry(defaultOption);
    //   setPhoneMask(defaultOption.phone_number_format.replace(/0/g, '9'));
    // }

  }, [defaultCodeValue, countryCodeArr]);

  const handleSelectChange = (option) => {
    const selectedCountry = countryCodeArr.find(
      (country) => country.country_id_ids === option.value
    );
    setSelectedCountry(selectedCountry);
    setPhoneMask(selectedCountry.phone_number_format.replace(/0/g, '9'));

    if (handleChangeCode) {
      handleChangeCode(option.value);
    }
  };

  // useEffect(() => {
  //   console.log("isEnteringNumber", isEnteringNumber)
  // }, [isEnteringNumber])

  const handleInputValueChange = (e) => {
    const rawInputValue = e.target.value;
    const isDeleting = e.nativeEvent.inputType === 'deleteContentBackward';

    const cleanedInputValue = rawInputValue.replace(/[\(\)\-\_\s]/g, '');
    const isNumericInput = /^[0-9]*$/.test(cleanedInputValue);

    const isEmailInput = !isNumericInput;

    if (isEmailInput) {
      const emailValidInput = /^[a-zA-Z0-9_\-@.]*$/.test(rawInputValue);

      if (emailValidInput) {
        setNumberDisplay(rawInputValue);
        handleInputValue({ target: { value: rawInputValue } });
        return;
      }
    }

    if (!isNumericInput || cleanedInputValue.length > 10) {
      setIsEnteringNumber(false); // Switch to email mode (no formatting)
      setNumberDisplay(cleanedInputValue);
      handleInputValue({ target: { value: cleanedInputValue } });
      return;
    }

    if (isNumericInput && cleanedInputValue.length <= 10) {
      let formattedValue = cleanedInputValue;

      if (selectedCountry && !isDeleting) {
        formattedValue = formatPhoneNumber(cleanedInputValue, selectedCountry.phone_number_format);
      }

      setNumberDisplay(formattedValue); // Display formatted phone number
      handleInputValue({ target: { value: cleanedInputValue } }); // Send raw number to parent
    }

  };

  function onBlurCheckInput() {
    handleOnBlur();
    if (inputValue?.length > 0 || isEnteringNumber) {
      setActivated(true);
    } else {
      setActivated(false);
    }
  }

  const onBlurFn = () => {
    if (inputValue?.length > 0 || isEnteringNumber) {
      onBlurCheckInput();
    } else {
      setActivated(false);
    }
  };

  const options = countryCodeArr.map(country => ({
    value: country.country_id_ids,
    label: `${country.country_phone_code_chr} ${country.country_name_chr}`
  }));

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      border: state.isFocused ? '1px solid #ced4da' : '1px solid #ced4da',
      boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(0, 123, 255, 0)' : 'none',
      width: '80px',
      marginRight: '5px',
      padding: '5px 3px',
      '&:hover': {
        border: '1px solid orange'
      },
      menu: (provided) => ({
        ...provided,
        zIndex: 5,
        width: '300px',
      }),
      menuList: (provided) => ({
        ...provided,
        width: '300px'
      }),
      option: (provided) => ({
        ...provided,
        padding: '10px',
        width: '100%'
      })
    })
  };

  const customComponents = {
    DropdownIndicator: null,
    IndicatorSeparator: null,
  };

  const formatPhoneNumber = (number, format) => {
    let formattedNumber = '';
    let numberIndex = 0;

    for (let i = 0; i < format.length; i++) {
      if (format[i] === '0') {
        if (numberIndex < number.length) {
          formattedNumber += number[numberIndex];
          numberIndex++;
        } else {
          break;
        }
      } else {
        formattedNumber += format[i]; // Insert formatting characters like () or -
      }
    }

    return formattedNumber;
  };

  return (
    <div className="mt-3 ">
      <div className="d-flex" style={{ justifyContent: 'space-between' }}>
        {isEnteringNumber &&
          (<div>
            <InputGroup
              ref={inputRef}
              className={errorOccured ? "" : "mb-3"}
              onFocus={() => setActivated(true)}
              style={{ width: '97%' }}
              onBlur={onBlurFn}

            >
              <Form.Group controlId="exampleForm.SelectCustom">
                <Form.Label
                  className={`${activated || inputValue?.length > 0
                    ? 'textfield-label-activated'
                    : 'textfield-label-unactivated'
                    } textfield-label`}
                  ref={labelRef}
                  onClick={() => {
                    setActivated(true);
                    inputRef?.current.focus();
                  }}
                  style={{ zIndex: 11 }}
                >
                  <strong> {"Code"}</strong>
                </Form.Label>
                <div
                  className={`${activated || inputValue?.length > 0
                    ? 'textfield-label-cover-activated'
                    : 'textfield-label-cover-unactivated'
                    } textfield-label-cover`}
                  style={{ width: '50px', zIndex: 10 }}
                ></div>
                <Select
                  options={options}
                  onChange={handleSelectChange}
                  value={
                    selectedCountry
                      ? {
                        value: selectedCountry.country_id_ids,
                        label: `${selectedCountry.country_phone_code_chr} ${selectedCountry.country_name_chr}`,
                      }
                      : null
                  }
                  isSearchable={true}
                  placeholder="Select or search code..."
                  styles={customStyles}
                  components={customComponents}
                  className="custom-select-menu"
                />
              </Form.Group>
            </InputGroup>
          </div>)
        }

        <div style={{ width: "100%" }}>
          <InputGroup
            className={errorOccured ? "" : "mb-3"}
            ref={inputRef}
            onFocus={() => setActivated(true)}
            onBlur={onBlurFn}
            style={{ background: 'white' }}
          >



            <Form.Control
              className={`rounded ${errorOccured && 'border border-danger'}`}
              style={{ zIndex: activated ? "" : 4, background: activated ? "" : "transparent" }}
              onFocus={() => setActivated(true)}
              onBlur={onBlurFn}
              onChange={handleInputValueChange}
              value={numberDisplay} // Display email or phone based on input
              autoFocus={autoF}
            />

            <label
              className={`${activated || inputValue?.length > 0 ? "textfield-label-activated activatedLabel" : "textfield-label-unactivated"} textfield-label ${errorOccured && 'text-danger'}`}
              style={{ zIndex: '4' }}
              ref={labelRef}
              onClick={() => {
                setActivated(true);
                inputRef?.current.focus();
              }}
            >
              {activated ? <strong className=""> {label === "" ? lblEmailOrMobileNumber : label} {isRequired ? "*" : ""}</strong> : <strong> {label === "" ? lblEmailOrMobileNumber : label} {isRequired ? "*" : ""}</strong>}
            </label>
            <div
              className={`${activated || inputValue?.length > 0 ? "textfield-label-cover-activated" : "textfield-label-cover-unactivated"} textfield-label-cover`}
              style={{ width: coverWidth, zIndex: '3' }}
            ></div>
          </InputGroup>
        </div>
      </div>
      {errorOccured && (
        <div className={`${!errorOccured ? "" : "mb-3"} text-danger fs-12`}>
          {errorMessage}
        </div>
      )}
    </div>
  );
};
export default EmailPhoneCombine;